var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.4535V1.50646C0 1.09215 0.1475 0.7375 0.4425 0.4425C0.7375 0.1475 1.09215 0 1.50646 0H11.4102C11.8245 0 12.1792 0.1475 12.4742 0.4425C12.7692 0.7375 12.9167 1.09215 12.9167 1.50646V5.66354C12.8125 5.64646 12.7083 5.63576 12.6042 5.63146C12.5 5.62715 12.3958 5.625 12.2917 5.625C12.1875 5.625 12.0833 5.62715 11.9792 5.63146C11.875 5.63576 11.7708 5.64646 11.6667 5.66354V1.50646C11.6667 1.4316 11.6426 1.37014 11.5946 1.32208C11.5465 1.27403 11.4851 1.25 11.4102 1.25H1.50646C1.4316 1.25 1.37014 1.27403 1.32208 1.32208C1.27403 1.37014 1.25 1.4316 1.25 1.50646V10H7.33021C7.31313 10.1042 7.30243 10.2083 7.29813 10.3125C7.29382 10.4167 7.29167 10.5208 7.29167 10.625C7.29167 10.7292 7.29382 10.8333 7.29813 10.9375C7.30243 11.0417 7.31313 11.1458 7.33021 11.25H2.20354L0 13.4535ZM3.17313 4.58333H9.74354V3.33333H3.17313V4.58333ZM3.17313 7.91667H7.24354V6.66667H3.17313V7.91667ZM11.6667 13.75V11.25H9.16667V10H11.6667V7.5H12.9167V10H15.4167V11.25H12.9167V13.75H11.6667Z",
    fill: "#0828B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatLogo);
export default __webpack_public_path__ + "static/media/new_chat_logo.11635cbd1907df6af9e4643f7a0931fe.svg";
export { ForwardRef as ReactComponent };